import React, { Suspense, lazy } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import Login from "./components/Login";
import "materialize-css/dist/css/materialize.min.css";
import "./App.css";
import { AuthProvider } from "./context/Auth";
import { useAuth } from "./hooks";
import Loader from "./components/common/Loader";

// Lazy load route components for code splitting
const Dashboard = lazy(() => import("./components/Dashboard"));
const AddClient = lazy(() => import("./components/AddClient"));
const ViewClient = lazy(() => 
  import("./components/ViewClient").then(m => ({ default: m.ViewClient }))
);
const EditClient = lazy(() => import("./components/EditProfile"));
const HomePage = lazy(() => import("./components/HomePage"));
const AdminLoginPage = lazy(() => import("./components/AdminLogin"));
const ViewClintPage = lazy(() => import("./components/ViewClint"));

function App() {
  const { user } = useAuth();

  return (
    <AuthProvider>
      <Router>
        <div className="content">
          <>
            <NavBar />
            <Suspense fallback={<Loader />}>
              <Routes>
                <Route exact path="/admin" element={<AdminLoginPage />} />
                {user ? (
                  <>
                    <Route
                      exact
                      path="/view/client"
                      element={<ViewClintPage />}
                    />
                    <Route exact path="/Dashboard" element={<Dashboard />} />
                    <Route exact path="/HomePage" element={<HomePage />} />
                    <Route exact path="/add/client" element={<AddClient />} />
                    <Route
                      exact
                      path="/view/client/:id"
                      element={<ViewClient />}
                    />
                    <Route
                      exact
                      path="/view/client/:id/edit"
                      element={<EditClient />}
                    />
                  </>
                ) : (
                  <Route exact path="/" element={<Login />} />
                )}
                <Route
                  path="*"
                  element={<Navigate to={user ? "/Homepage" : "/"} />}
                />
              </Routes>
            </Suspense>
          </>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
